import React from "react";
import CatalogBrowser from "../components/CatalogBrowser";

/**
 * The catalogue. Everything it does lives in CatalogBrowser, which the author
 * and narrator pages render with a filter pinned — /browse?narrator=Diana+Reyes
 * and /narrator/Diana%20Reyes are the same view, one linkable, one canonical.
 */
export default function Browse() {
  return <CatalogBrowser />;
}
